module.exports = __webpack_public_path__ + "img/warning-cohua.54d61a66.png";